export const fmtBRL = (v) => {
    const n = Number(v);
    if (Number.isNaN(n)) return "-";
    return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export function findBestMatchByCode(products, code) {
    const normalized = String(code || "").trim();
    const matches = (products || []).filter(
        (p) => String(p.product_id_produto || "").trim() === normalized
    );

    if (!matches.length) return null;

    const sorted = [...matches].sort((a, b) => {
        const da = new Date(a.kit__pay_date || 0).getTime() || 0;
        const db = new Date(b.kit__pay_date || 0).getTime() || 0;
        return db - da;
    });

    return sorted[0];
}
